export default "__VITE_ASSET__BA2Kna$p__"